<template>
  <fieldset class="relative">
    <legend>
      Weighbridge Docket #{{ index + 1 }}

      <span class="text-danger pull-right" v-if="docketIsResubmit">
        RESUBMIT
      </span>
    </legend>

    <ladda-button v-if="canDelete" :on-click="handleDeleteDocket" type="danger" class="btn-circle btn-remove-docket">
      <i class="fa fa-trash"></i>
    </ladda-button>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group-outer">
          <div class="form-group float-label-control float-label-no-animation">
            <label for="" class="select-label">Docket Number</label>
            <input type="text" class="form-control" v-model="number" :disabled="disabled">
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group-outer">
          <div class="form-group float-label-control float-label-no-animation">
            <label for="" class="select-label">Net {{ type }} Weight</label>
            <div class="input-group">
              <input type="number" min="0" step="0.01" class="form-control" v-model="weight" :disabled="disabled">
              <span class="input-group-addon">tonne</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div :class="{ 'col-sm-6 col-md-7': notDisabled, 'col-sm-12': disabled }">
        <div class="form-group float-label-control float-label-no-animation">
          <label for="" class="select-label">Docket Image</label>
          <input type="text" class="form-control" :value="file" disabled>
        </div>
      </div>
      <div class="col-sm-6 col-md-5" v-if="notDisabled">
        <label class="btn btn-primary btn-sm btn-block m-b-md" :for="`docket-${identifiers.index}`">
          <input
            type="file"
            class="sr-only"
            name="file"
            :id="`docket-${identifiers.index}`"
            accept=".jpg,.jpeg,.png,.gif"
            @change="handleFileSelection">
          Select File
        </label>
      </div>
    </div>
  </fieldset>
</template>

<script>
  import { LaddaButton } from 'components/forms'
  import { SET_DOCKET_ATTRIBUTE, REMOVE_DOCKET } from 'vx/mutations'
  import { mapMutations } from 'vuex'
  import { docketStateMapper, docketActionsHelpers } from 'mixins/weighbridge'
  import { jobHelpers } from 'mixins/jobs'

  export default {
    props: ['docket', 'index', 'type'],

    mixins: [docketStateMapper, docketActionsHelpers, jobHelpers],

    components: {
      LaddaButton
    },

    computed: {
      identifiers () {
        return { index: this.docket.index, id: this.docket.id }
      },

      docketIsResubmit () {
        return this.docket.status === 'resubmit'
      },

      canDelete () {
        return this.jobIsEditable && (this.docket.id === null || this.$user.isAdminOrCoordinator)
      },

      disabled () {
        if (this.jobIsNotEditable) {
          return true
        }

        if (this.docket.id === null || this.$user.isAdmin || this.docket.status === 'resubmit') {
          return false
        }

        return true
      },

      notDisabled () {
        return this.disabled === false
      }
    },

    data () {
      return {}
    },

    methods: {
      ...mapMutations('weighbridge', [SET_DOCKET_ATTRIBUTE, REMOVE_DOCKET])
    }
  }
</script>



// WEBPACK FOOTER //
// WeighbridgeDocketItem.vue?341f4674